import React from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { GridComponent, TooltipComponent } from 'echarts/components';
import { CustomChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import dayjs from 'dayjs';
import { Card } from 'react-bootstrap';

echarts.use([GridComponent, TooltipComponent, CustomChart, CanvasRenderer]);

// ✅ Map STATE → nivel
const STATUS_MAP = {
  RUNNING: 2,
  INACTIVE: 0
};

const MODE_MAP = {
  PRODUCTION: 3,
  'CLEAN UP': 2,
  UNWINDING: 1,
  UNKNOWN: 0
};
// 🎨 Culori
const STATUS_COLORS = {
  0: '#6c757d', // inactive
  2: '#198754' // running
};

const MODE_COLORS = {
  0: '#6c757d',
  1: '#0dcaf0',
  2: '#ffc107',
  3: '#198754'
};

const StateTimelineChart = ({
  title = 'State Timeline',
  data = [],
  type = 'STATUS'
}) => {
  if (!data || !data.length) return null;

  const MAP = type === 'MODE' ? MODE_MAP : STATUS_MAP;
  const COLORS = type === 'MODE' ? MODE_COLORS : STATUS_COLORS;

  // ✅ Transformăm în tuple pentru timeline
  const entries = data.map(([time, value]) => {
    const normalized =
      typeof value === 'string' ? MAP[value.toUpperCase()] ?? 0 : value;

    return [+new Date(time), normalized];
  });

  const option = {
    tooltip: {
      formatter: params => {
        const time = dayjs(params.value[0]).format('HH:mm:ss');
        const state = Object.keys(MAP).find(k => MAP[k] === params.value[1]);
        return `<b>${time}</b><br/>${type}: <b>${state || 'UNKNOWN'}</b>`;
      }
    },

    grid: {
      top: 20,
      bottom: 20,
      left: 10,
      right: 10
    },

    xAxis: {
      type: 'time',
      axisLabel: {
        formatter: v => dayjs(v).format('HH:mm')
      }
    },

    yAxis: {
      type: 'value',
      min: 0,
      max: type === 'MODE' ? 3 : 2,
      show: false
    },

    series: [
      {
        type: 'custom',
        renderItem: (params, api) => {
          const x = api.coord([api.value(0), api.value(1)]);
          const size = api.size([1000 * 2, 1]);
          const color = COLORS[api.value(1)] || '#000';

          return {
            type: 'rect',
            shape: {
              x: x[0],
              y: params.coordSys.y + 10,
              width: size[0],
              height: params.coordSys.height - 20
            },
            style: {
              fill: color
            }
          };
        },
        encode: { x: 0, y: 1 },
        data: entries
      }
    ]
  };

  return (
    <Card>
      <Card.Body>
        <h6 className="fw-bold mb-2">{title}</h6>
        <ReactEChartsCore
          echarts={echarts}
          option={option}
          style={{ height: 200 }}
        />
      </Card.Body>
    </Card>
  );
};

export default StateTimelineChart;
